import { AsyncStatus } from 'lib-shared-legacy-types';
import { handleActions } from 'redux-actions';


import { actions } from '../actions/typing';

// Destructure the typing actions.
export const {
  typingSend,
  typingSendSucceeded,
  typingSendFailed,

  typingAdd,
  typingRemove,
} = actions;

export type TypingType = {
  csid: number | null;
  userId: string | null;
};

export type TypingState = {
  meta: {
    asyncStatus: AsyncStatus;
  };
  typings: Array<TypingType>;
};

// Init state for the Typing.
const initialState: TypingState = {
  meta: {
    asyncStatus: 'succeeded',
  },
  typings: [],
};

// Reducer
const typing = handleActions<TypingState, any>(
  {
    // typing actions.
    [typingSend.toString()]: (state: TypingState) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'loading' } };
    },

    [typingSendSucceeded.toString()]: (state: TypingState) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'succeeded' } };
    },

    [typingSendFailed.toString()]: (state: TypingState) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'failed' } };
    },

    [typingAdd.toString()]: (state: TypingState, action: any) => {
      const typings = state.typings.slice();
      let found = false;

      const typing = {
        csid: action.payload.params.csid,
        userId: action.payload.params.user_id,
      };

      for (const t of typings) {
        if (typing.csid === t.csid) {
          found = true;
        }
      }
      if (found === false) {
        typings.push(typing);
      }

      return { ...state, typings: typings };
    },

    [typingRemove.toString()]: (state: TypingState, action: any) => {
      return {
        ...state,
        typings: state.typings.filter(
          (t) => t.csid !== action.payload.params.csid,
        ),
      };
    },
  },
  initialState,
);

export default typing;
